import type { TIconProps } from "./types";

export const VkIcon = (props: TIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1104_665)">
        <path
          d="M0 11.52C0 6.0894 0 3.37413 1.68707 1.68707C3.37413 0 6.0894 0 11.52 0H12.48C17.9106 0 20.6259 0 22.313 1.68707C24 3.37413 24 6.0894 24 11.52V12.48C24 17.9106 24 20.6259 22.313 22.313C20.6259 24 17.9106 24 12.48 24H11.52C6.0894 24 3.37413 24 1.68707 22.313C0 20.6259 0 17.9106 0 12.48V11.52Z"
          fill="#0077FF"
        />
        <path
          d="M12.7702 17.2901C7.30024 17.2901 4.18029 13.54 4.05029 7.30005H6.79029C6.88029 11.88 8.90024 13.82 10.5002 14.22V7.30005H13.0803V11.25C14.6603 11.08 16.3201 9.28005 16.8801 7.30005H19.4602C19.0302 9.74005 17.2302 11.5401 15.9502 12.28C17.2302 12.8801 19.2803 14.4501 20.0603 17.2901H17.2202C16.6102 15.3901 15.0903 13.92 13.0803 13.72V17.2901H12.7702Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1104_665">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
